import React, { Component } from "react";
import { Wrapper, Card, CardBody } from "app/NativeComponents/common";

import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from "react-stripe-elements";

class Inputs extends Component {
  render() {
    return (
      <Card>
        <CardBody>
          <div className="standard-label">
            <label>Card Number</label>
          </div>
          <CardNumberElement style={{ base: { fontSize: "18px" } }} />
        </CardBody>

        <CardBody>
          <div className="standard-label">
            <label>Expiration Date</label>
          </div>
          <CardExpiryElement style={{ base: { fontSize: "18px" } }} />
        </CardBody>
        <CardBody>
          <div className="standard-label">
            <label>CVC</label>
          </div>
          <CardCVCElement style={{ base: { fontSize: "18px" } }} />
        </CardBody>
      </Card>
    );
  }
}

export default Inputs;
